import {
  LIST_COMMUNITY_DOOR_ACCESSES_REQUEST,
  LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE,
  LIST_COMMUNITY_UNITS_REQUEST,
  LIST_COMMUNITY_UNITS_RESPONSE,
  FETCH_UNIT_REQUEST,
  FETCH_UNIT_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// Permissions-based functionality & data security is enforced in the backend;
// this UI Config store SHOULD NOT be used to enforce data security in the client
// by way of UI (i.e. not rendering stuff).
// That data shouldn't be returned to the client in the first place.
// These configs are only for hiding UI which would otherwise not work.

const initialState = {
  showDoorAccessUI: false,
  showUnitControlUI: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITY_DOOR_ACCESSES_REQUEST:
      return {
        ...state,
        showDoorAccessUI: false,
      }

    case LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE:
      return {
        ...state,
        showDoorAccessUI: (action.perms && action.perms.door_access),
      }

    case LIST_COMMUNITY_UNITS_REQUEST:
    case FETCH_UNIT_REQUEST:
      return {
        ...state,
        showUnitControlUI: false,
      }

    case LIST_COMMUNITY_UNITS_RESPONSE:
    case FETCH_UNIT_RESPONSE:
      return {
        ...state,
        showUnitControlUI: (action.perms && action.perms.unit_control),
      }

    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
